import type { ContentItem } from '@/types/content';
import SectionTitle from '@/components/base/SectionTitle';
import ContentCard from '@/components/base/ContentCard';

interface EntHotProps {
  items: ContentItem[];
}

export default function EntHot({ items }: EntHotProps) {
  return (
    <section className="mx-auto mt-10 max-w-[1440px] px-4 md:mt-14 md:px-6">
      <SectionTitle
        title="娱乐热点"
        subtitle="影视 · 音乐 · 游戏 · 综艺"
        icon="ri-movie-2-line"
        moreTo="/category/entertainment"
      />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {items.slice(0, 4).map((item) => (
          <ContentCard key={item.id} item={item} />
        ))}
      </div>
    </section>
  );
}